import type { Catalog } from "../../en";

/** Filipino: platform admin dashboard screen (mirrors en). */
export const dashboard: Catalog["adminScreens"]["dashboard"] = {
  title: "Pangkalahatang-tanaw ng platform",
  subtitle: "Lahat ng tenant, kita at gastos sa AI sa buong Sagot · as of {{when}} PHT",
  periods: { label: "Panahon ng ulat", mtd: "Ngayong buwan", qtd: "Quarter", ytd: "Taon" },
  exportReport: "I-export ang ulat",
  exportUnavailable: "Hindi pa available ang pag-export ng board report",
  createTenant: "Gumawa ng tenant",
  status: {
    title: "Status ng sistema",
    allUp: "Lahat gumagana",
    degraded: "Degraded: {{count}}",
    down: "Down: {{count}}",
    unknown: "Hindi alam: {{count}}",
    open: "Buksan ang System Health",
    states: { up: "Gumagana", degraded: "Degraded", down: "Down", unknown: "Hindi alam" },
  },
  kpi: {
    mrrUsd: "≈ {{usd}} sa nakatakdang FX rate",
    mrr: "MRR",
    mrrDelta: "{{delta}} kumpara sa {{month}}",
    mrrFlat: "Walang pagbabago mula {{month}}",
    active: "Aktibong tenant",
    activeDelta: "+{{count}} ngayong buwan",
    activeFoot: "{{count}} naka-suspend",
    paying: "Nagbabayad",
    payingFoot: "ARPA {{arpa}} · {{pastDue}} lampas sa due",
    trial: "Naka-trial",
    trialFoot_one: "{{count}} mag-e-expire sa susunod na 7 araw",
    trialFoot_other: "{{count}} mag-e-expire sa susunod na 7 araw",
    churn: "Logo churn (30 araw)",
    churnFoot_one: "{{count}} pagkansela",
    churnFoot_other: "{{count}} pagkansela",
    messages: "Mga mensahe ngayong buwan",
    messagesPeriod: "Mga mensahe ({{period}})",
    messagesFoot: "user + AI · {{conversations}} usapan",
    aiCost: "Gastos sa AI ({{period}})",
    aiCostFoot: "≈ {{php}}",
    aiCostBudget: "≈ {{php}} · {{pct}} ng {{budget}} na budget",
    margin: "Gross margin",
    marginFoot: "Kita {{revenue}} sa panahong ito",
  },
  mrr: {
    title: "Takbo ng MRR",
    subtitle: "{{from}} – {{to}} · recurring na subscription + add-on, bawas ang discount",
    growth: "{{multiple}}× sa loob ng 12 buwan",
    chart: "Monthly recurring revenue, huling 12 buwan",
    series: "MRR",
    change: "Pagbabago mula noong nakaraang buwan",
    best: "Pinakamataas na buwan",
    average: "Average sa 12 buwan",
    months: "Mga buwang may kita",
  },
  signups: {
    title: "Signups vs conversions",
    subtitle: "Mga nagsimulang trial vs naging bayad",
    signups: "Signups",
    converted: "Na-convert",
    chart: "Signups at conversion bawat buwan",
    rate: "Trial → bayad (6 buwan)",
    total: "Signups (6 buwan)",
    bar: "{{month}}: {{signups}} signup, {{converted}} na-convert",
  },
  industry: {
    title: "Mga tenant ayon sa industriya",
    subtitle_one: "{{count}} aktibong tenant",
    subtitle_other: "{{count}} aktibong tenant",
    browse: "Tingnan ang mga tenant",
    item: "{{count}} tenant · {{mrr}} MRR",
    itemNoMrr: "{{count}} tenant",
    segment: "{{label}} — {{count}} tenant ({{pct}})",
    largest: "Pinakamalaking segment",
    highestMrr: "Pinakamataas na MRR",
    industries: "Mga industriya",
  },
  plans: {
    title: "Halo ng plan",
    manage: "Pamahalaan ang mga plan",
    row: "{{count}} · {{mrr}}",
    rowNoMrr: "{{count}} tenant",
    custom: "custom",
  },
  recent: {
    title: "Mga bagong signup",
    all: "Lahat ng tenant",
    colTenant: "Tenant",
    colIndustry: "Industriya",
    colPlan: "Plan",
    colOwner: "Owner",
    colSignedUp: "Nag-sign up",
    emptyTitle: "Wala pang tenant",
    emptyBody: "Lalabas dito ang mga bagong workspace sa sandaling mag-sign up sila.",
  },
  alerts: {
    title: "Mga alerto",
    open_one: "{{count}} bukas",
    open_other: "{{count}} bukas",
    emptyTitle: "Walang bukas na alerto",
    emptyBody: "Dito lalabas ang mga usage limit, bigong bayad, ulat ng abuso at pagdami sa queue.",
    viewTenant: "Tingnan ang tenant",
    reviewCase: "Suriin ang kaso",
    seeCosts: "Tingnan ang gastos",
    openSystem: "Buksan ang System Health",
    dismiss: "I-dismiss",
    dismissed: "Na-dismiss ang alerto",
  },
};
